'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _runtime = require('handlebars/runtime');

var _runtime2 = _interopRequireDefault(_runtime);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('../handlebars_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var template = _runtime2.default.template({
  "1": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {};
    return ((stack1 = helpers["if"].call(alias1, depth0 != null ? depth0.title : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(2, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + ((stack1 = helpers["if"].call(alias1, depth0 != null ? depth0.subtitle : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(4, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + ((stack1 = helpers["if"].call(alias1, depth0 != null ? depth0.bodyLines : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(6, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "");
  },
  "2": function _(container, depth0, helpers, partials, data) {
    var helper;
    return "<h1>" + container.escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data
    }) : helper)) + "</h1>";
  },
  "4": function _(container, depth0, helpers, partials, data) {
    var helper;
    return "<h2>" + container.escapeExpression((helper = (helper = helpers.subtitle || (depth0 != null ? depth0.subtitle : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data
    }) : helper)) + "</h2>";
  },
  "6": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1;
    return "<div class=\"chord-sheet\">" + ((stack1 = helpers.each.call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? depth0.paragraphs : depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(7, data, 1, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + "</div>";
  },
  "7": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {};
    return "<div class=\"" + container.escapeExpression((helpers.paragraphClasses || depth0 && depth0.paragraphClasses || helpers.helperMissing).call(alias1, blockParams[0][0], {
      "name": "paragraphClasses",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    })) + "\">" + ((stack1 = helpers.each.call(alias1, depth0 != null ? depth0.lines : depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(8, data, 1, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + "</div>";
  },
  "8": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {};
    return (stack1 = helpers["if"].call(alias1, (helpers.shouldRenderLine || depth0 && depth0.shouldRenderLine || helpers.helperMissing).call(alias1, blockParams[0][0], {
      "name": "shouldRenderLine",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    }), {
      "name": "if",
      "hash": {},
      "fn": container.program(9, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "";
  },
  "9": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = helpers.helperMissing;
    return "<table class=\"" + container.escapeExpression((helpers.lineClasses || depth0 && depth0.lineClasses || alias2).call(alias1, blockParams[1][0], {
      "name": "lineClasses",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    })) + "\">" + ((stack1 = helpers["if"].call(alias1, (helpers.hasChordContents || depth0 && depth0.hasChordContents || alias2).call(alias1, blockParams[1][0], {
      "name": "hasChordContents",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    }), {
      "name": "if",
      "hash": {},
      "fn": container.program(10, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + ((stack1 = helpers["if"].call(alias1, (helpers.hasTextContents || depth0 && depth0.hasTextContents || alias2).call(alias1, blockParams[1][0], {
      "name": "hasTextContents",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    }), {
      "name": "if",
      "hash": {},
      "fn": container.program(14, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + "</table>";
  },
  "10": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1;
    return "<tr>" + ((stack1 = helpers.each.call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? depth0.items : depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(11, data, 1, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + "</tr>";
  },
  "11": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {};
    return (stack1 = helpers["if"].call(alias1, (helpers.isChordLyricsPair || depth0 && depth0.isChordLyricsPair || helpers.helperMissing).call(alias1, blockParams[0][0], {
      "name": "isChordLyricsPair",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    }), {
      "name": "if",
      "hash": {},
      "fn": container.program(12, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "";
  },
  "12": function _(container, depth0, helpers, partials, data) {
    var helper;
    return "<td class=\"chord\">" + container.escapeExpression((helper = (helper = helpers.chords || (depth0 != null ? depth0.chords : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "chords",
      "hash": {},
      "data": data
    }) : helper)) + "</td>";
  },
  "14": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1;
    return "<tr>" + ((stack1 = helpers.each.call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? depth0.items : depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(15, data, 1, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + "</tr>";
  },
  "15": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = helpers.helperMissing;
    return ((stack1 = helpers["if"].call(alias1, (helpers.isChordLyricsPair || depth0 && depth0.isChordLyricsPair || alias2).call(alias1, blockParams[0][0], {
      "name": "isChordLyricsPair",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    }), {
      "name": "if",
      "hash": {},
      "fn": container.program(16, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "") + ((stack1 = helpers["if"].call(alias1, (helpers.isTag || depth0 && depth0.isTag || alias2).call(alias1, blockParams[0][0], {
      "name": "isTag",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    }), {
      "name": "if",
      "hash": {},
      "fn": container.program(18, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "");
  },
  "16": function _(container, depth0, helpers, partials, data) {
    var helper;
    return "<td class=\"lyrics\">" + container.escapeExpression((helper = (helper = helpers.lyrics || (depth0 != null ? depth0.lyrics : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "lyrics",
      "hash": {},
      "data": data
    }) : helper)) + "</td>";
  },
  "18": function _(container, depth0, helpers, partials, data, blockParams) {
    var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {};
    return (stack1 = helpers["if"].call(alias1, (helpers.isComment || depth0 && depth0.isComment || helpers.helperMissing).call(alias1, blockParams[1][0], {
      "name": "isComment",
      "hash": {},
      "data": data,
      "blockParams": blockParams
    }), {
      "name": "if",
      "hash": {},
      "fn": container.program(19, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "";
  },
  "19": function _(container, depth0, helpers, partials, data) {
    var helper;
    return "<td class=\"comment\">" + container.escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helpers.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "value",
      "hash": {},
      "data": data
    }) : helper)) + "</td>";
  },
  "compiler": [7, ">= 4.0.0"],
  "main": function main(container, depth0, helpers, partials, data, blockParams) {
    var stack1;
    return (stack1 = helpers["with"].call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? depth0.song : depth0, {
      "name": "with",
      "hash": {},
      "fn": container.program(1, data, 0, blockParams),
      "inverse": container.noop,
      "data": data,
      "blockParams": blockParams
    })) != null ? stack1 : "";
  },
  "useData": true,
  "useBlockParams": true
});

/**
 * Formats a song into HTML. It uses TABLEs to align lyrics with chords, which makes the HTML for things like
 * PDF conversion.
 */

var HtmlTableFormatter = function () {
  function HtmlTableFormatter() {
    _classCallCheck(this, HtmlTableFormatter);
  }

  _createClass(HtmlTableFormatter, [{
    key: 'format',

    /**
     * Formats a song into HTML.
     * @param {Song} song The song to be formatted
     * @returns {string} The HTML string
     */
    value: function format(song) {
      return template({ song: song });
    }
  }]);

  return HtmlTableFormatter;
}();

exports.default = HtmlTableFormatter;


//////////////////
// WEBPACK FOOTER
// ./~/chordsheetjs/lib/formatter/html_table_formatter.js
// module id = 171
// module chunks = 1